module.exports = __webpack_public_path__ + "static/media/88.29fef1ff.jpg";